import React, { FC, ChangeEvent, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Select, ISelectProps } from 'transfix-ui/components/Select'
import { TextField } from 'transfix-ui/components/TextField'
import Box from 'transfix-ui/core/Box'
import { conditionOptions } from 'apps/marketplace/components/rfp/constants/strategyManager'
import {
  ILaneCriteria,
  ICriteriaCondition,
  ConditionTypes,
} from 'apps/marketplace/components/rfp/types/strategyManager'
import { isValidNumericValue } from 'apps/marketplace/components/rfp/utils/strategyManager'

interface IMarketDemandScoreInputProps {
  value: ICriteriaCondition | null
  onSave: (changes: Partial<ILaneCriteria>) => void
  onCancel: () => void
}

export const MarketDemandScoreInput: FC<IMarketDemandScoreInputProps> = ({
  onCancel,
  onSave,
  value,
}) => {
  const [marketDemandScore, setMarketDemandScore] = useState<Partial<ICriteriaCondition>>(
    value || {}
  )

  const onConditionChange: ISelectProps['onChange'] = e => {
    e.stopPropagation()

    const newMarketDemandScore = {
      ...marketDemandScore,
      condition: e.target.value as ConditionTypes,
    } as ICriteriaCondition

    setMarketDemandScore(newMarketDemandScore)
  }

  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newMarketDemandScore = {
      ...marketDemandScore,
      value: e.target.value,
    } as ICriteriaCondition

    setMarketDemandScore(newMarketDemandScore)
  }

  const saveHandler = () => {
    onSave({
      marketDemandScore: marketDemandScore as ICriteriaCondition,
    })
  }

  const isValid = isValidNumericValue(marketDemandScore.value || '')

  return (
    <>
      <Box mb={1} display='flex' alignItems='end'>
        <Box mr={1} flexGrow={1}>
          <Select
            label='Condition'
            value={marketDemandScore.condition}
            options={conditionOptions}
            onChange={onConditionChange}
            required
            large
          />
        </Box>
        <Box ml={1} flexGrow={1}>
          <TextField
            label='Score'
            placeholder='Score'
            value={marketDemandScore.value}
            onChange={onValueChange}
            error={!isValid}
            required
            large
          />
        </Box>
      </Box>
      <Box display='flex' justifyContent='flex-end'>
        <Box>
          <Button color='tertiary' onClick={onCancel}>
            Cancel
          </Button>
        </Box>
        <Box ml={1}>
          <Button color='primary' onClick={saveHandler} disabled={!isValid}>
            Save
          </Button>
        </Box>
      </Box>
    </>
  )
}
